import { Transform, type ReadFileSystem } from '@playcanvas/splat-transform';
import { Mat4, Quat, Vec3 } from 'playcanvas';

// what an LCC2 export needs from the original: kept on the resource for the
// session only, never saved into a project
type Lcc2Origin = {
    indexName: string;
    indexText: string;
    lod: number;
    // resource row -> row in the LOD stream (the loader's morton order), captured
    // at import because a later rebind replaces the resource's source
    rowToStream: Uint32Array | null;
    fileSystem: ReadFileSystem;
    files: string[];
};

// the rotation splat-transform reports for LCC2 and the loader applies to the entity
const lcc2ImportMatrix = () => {
    const { rotation } = new Transform().fromEulers(90, 0, 180);
    return new Mat4().setTRS(Vec3.ZERO, new Quat(rotation.x, rotation.y, rotation.z, rotation.w), Vec3.ONE);
};

export { lcc2ImportMatrix, type Lcc2Origin };
